export default __webpack_public_path__ + "static/media/gitbook.5f888e46.svg";